module.exports = __webpack_public_path__ + "img/icons B_9.dc7594f6.png";